import { create } from 'zustand';

const MAX_JOURNEY_LIMIT_FOR_FREE_PLAN = 2;
const MAX_JOURNEY_LIMIT_FOR_STARTER_PLAN = 2; // Updated to match new pricing table

export const useJourneys = create((set) => ({
  journeys: [],
  hasReachedFreeLimit: null,
  journeysLoaded: false,
  setHasReachedFreeLimit: (organisation,subscriptionPlanType) => {
    set({
  
      hasReachedFreeLimit: (organisation.is_subscribed && (subscriptionPlanType==='pro' || subscriptionPlanType==='enterprise' ) )
        ? false
        : (organisation.journey_count >= (subscriptionPlanType==='starter'?MAX_JOURNEY_LIMIT_FOR_STARTER_PLAN:MAX_JOURNEY_LIMIT_FOR_FREE_PLAN)),
    });
  },
  setJourneys: (journeys,subscriptionPlanType) => {
    set(() => ({
      journeys: journeys,
      hasReachedFreeLimit: journeys.length >= (subscriptionPlanType==='starter'?MAX_JOURNEY_LIMIT_FOR_STARTER_PLAN:MAX_JOURNEY_LIMIT_FOR_FREE_PLAN),
    }));
  },
  updateJourney: (journey) => {
    set((state) => ({
      journeys: state.journeys.map((j) => {
        return j.uuid === journey.uuid ? journey : j;
      }),
    }));
  },
  deleteJourney: (uuid,subscriptionPlanType) => {
    set((state) => {
      const journeys = state.journeys.filter((j) => {
        return j.uuid !== uuid;
      });
      return {
        journeys,
        hasReachedFreeLimit: journeys.length >= (subscriptionPlanType==='starter'?MAX_JOURNEY_LIMIT_FOR_STARTER_PLAN:MAX_JOURNEY_LIMIT_FOR_FREE_PLAN),
      };
    });
  },
  createJourney: (journey,subscriptionPlanType) => {
    set((state) => {
      const journeys = [...state.journeys, journey];
      return {
        journeys,
        hasReachedFreeLimit: journeys.length >= (subscriptionPlanType==='starter'?MAX_JOURNEY_LIMIT_FOR_STARTER_PLAN:MAX_JOURNEY_LIMIT_FOR_FREE_PLAN),
      };
    });
  },
  prependJourney: (journey,subscriptionPlanType) => {
    set((state) => {
      const journeys = [journey, ...state.journeys];
      return {
        journeys,
        hasReachedFreeLimit: journeys.length >= (subscriptionPlanType==='starter'?MAX_JOURNEY_LIMIT_FOR_STARTER_PLAN:MAX_JOURNEY_LIMIT_FOR_FREE_PLAN),
      };
    });
  },
  setJourneysLoaded: (journeysLoaded) => {
    set((state) => ({
      journeysLoaded: journeysLoaded,
    }));
  },
}));
